import React from "react";

const Checkbox = ({ id, type, name, handleClick, className = 'checkbox', isChecked = false }) => {
    return (
        <input
            id={id}
            name={name}
            type={type}
            onChange={handleClick}
            checked={isChecked}
            className={className}
        />
    );
};

export default Checkbox;
